import { ALGOLIA_HAS_LISTABLE_STOCK_FILTER } from 'commons/constants';
import { buildInStockWarehouseFilterClause } from 'components/consumer/category-page-algolia/buildInStockWarehouseFilterClause';
import { IN_STOCK_WAREHOUSE_FIELD } from 'components/consumer/category-page-algolia/categoryPageTypes';

/**
 * Builds the Algolia `filters` string for `/search`. The search modal has no
 * Ready-to-Ship toggle and still uses `ALGOLIA_HAS_LISTABLE_STOCK_FILTER`
 * directly.
 *
 * Ready-to-ship must live in `filters` rather than `Configure.facetFilters`.
 * When a color is selected the `option_color` refinementList widget generates
 * its own `facetFilters`, which fully overrides any `facetFilters` set via
 * Configure. `filters` is an independent parameter, so it ANDs with the color
 * refinement instead of being replaced by it.
 *
 * The toggle matches cart/PDP: zip warehouse OR default DC (`154`). Without a
 * zip there is no warehouse to scope by, so it uses `is_in_stock:true`. Ids
 * are unquoted on purpose: in Algolia `attr:154` (numeric) and `attr:"154"`
 * (string) are not equivalent.
 */
const buildSearchAlgoliaConfigureFilters = ({
  isReadyToShipActive,
  warehouseId,
  hasUserZip = false,
} = {}) => {
  const parts = [ALGOLIA_HAS_LISTABLE_STOCK_FILTER];

  if (isReadyToShipActive) {
    parts.push(
      buildInStockWarehouseFilterClause({
        warehouseId,
        hasUserZip,
        field: IN_STOCK_WAREHOUSE_FIELD,
      })
    );
  }

  return parts.join(' AND ');
};

export default buildSearchAlgoliaConfigureFilters;
